import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CookieBanner } from './components/CookieBanner';
import { initAnalytics } from './services/analytics';
import './index.css';

initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* auth lives in the lazily loaded app shell (components/AppShell), not around the landing */}
      <App />
      <CookieBanner />
    </BrowserRouter>
  </React.StrictMode>,
);
